//import { useMemo } from "react";
//import LoadConvergenceAds from "../../../components/advertisement/load-convergence-ads";
import ConvergenceHeader from "../../../components/header/convergence-2023-header";
import ConvergenceLayoutStyleComponent from "../../../containers/components/convergence-2023-layout-style.component";

type headerBanner = {
  bannerImage: string;
  headerText: string;
  topCommonMesage: string;
  mobileBanner: string;
};

const Convergence2023Banner = (props: headerBanner) => {
//const cachedGoogleAdsLoader = useMemo(() => <LoadConvergenceAds />, []);

  return (
    <>
      {/*cachedGoogleAdsLoader*/}
      <ConvergenceLayoutStyleComponent />
      <ConvergenceHeader />

      <ConvergenceBannerStyleComponent {...props} />
      <div id="header-image" className="header-image">
        <span className="hide">&nbsp;</span>
        <img src={props.mobileBanner} alt="" className="mobile-image" />
        <div className="top-text" dangerouslySetInnerHTML={{ __html: props.headerText }}></div>
      </div>

      <div dangerouslySetInnerHTML={{ __html: props.topCommonMesage }}></div>
      <div className="bottom-text" dangerouslySetInnerHTML={{ __html: props.headerText }}></div>
    </>
  );
};

export default Convergence2023Banner;

const ConvergenceBannerStyleComponent = (props: headerBanner) => {
  return (
    <>
      <style>
        {`
          @media(min-width: 1024px){
            .header-image{
              background-image: url( ${props.bannerImage});
              background-position: center bottom !important;
            }
          }
          @media(min-width: 1024px){
            .mobile-image{
              display: none;
            }
          }
          @media(max-width: 1024px){
            .top-text{
              display: none;
            } 
          }
          @media(min-width: 1025px){
            .bottom-text{
              display: none;
            }
          }
        `}
      </style>
    </>
  );
};
